// src/components/ImpersonationBanner.js
import React, { useEffect, useState } from 'react';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';

// Shows a fixed banner ONLY when the current session was started via admin
// impersonation (custom token carried an `impersonatedBy` claim).
// Renders null for every normal session, so regular users are unaffected.
function ImpersonationBanner() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (!u) { setInfo(null); return; }
      try {
        const res = await u.getIdTokenResult();
        setInfo(res.claims && res.claims.impersonatedBy ? { email: u.email || u.uid } : null);
      } catch (e) {
        setInfo(null);
      }
    });
    return () => unsub();
  }, []);

  if (!info) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
      background: '#b91c1c', color: '#fff', textAlign: 'center',
      padding: '8px 12px', fontWeight: 700, fontSize: 14, fontFamily: 'sans-serif',
      boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
    }}>
      👁️ You are viewing as {info.email} — admin impersonation session
    </div>
  );
}

export default ImpersonationBanner;
